import { axiosInstance } from "../api/axios";
import { AuthorizeRequest, AuthorizeResponse } from "../models/Authorize";
import { authLoginURL } from "../constants/urls";
import {ApiResponse} from "../models/ApiResponse";

export const Authorize = async (authData: AuthorizeRequest) => {
  const params = new URLSearchParams({ ...authData });

  const result = await axiosInstance.post<AuthorizeResponse>("token", params, {
    baseURL: authLoginURL,
  });

  return result.data;
};

export const RevokeToken = async () => {
  const result = await axiosInstance.post<ApiResponse<boolean>>("oauth/token/revoke");
  return result.data;
}
